import { notification } from "antd";
import { useCallback } from "react";
import { SubmitHandler } from "react-hook-form";
import { SchemaFormConstatGravity } from "../../../../components/forms/FormConstatGravity";
import {
  useCreateConstatGravityMutation,
  useDeleteConstatGravityMutation,
  useUpdateConstatGravityMutation,
} from "../../apiSlice";
import { getErrorMessage } from "../../../../utils/errors/errors";

type FetchConstatGravities = () => void;

export const useCrudConstatGravity = (
  constatGravityId: number,
  fetchConstatGravities: FetchConstatGravities,
  onHideModal: () => void,
) => {
  const [lazyCreateConstatGravity, { isLoading: isCreating }] =
    useCreateConstatGravityMutation();
  const [lazyUpdateConstatGravity, { isLoading: isUpdating }] =
    useUpdateConstatGravityMutation();
  const [lazyDeleteConstatGravity, { isLoading: isDeleting }] =
    useDeleteConstatGravityMutation();

  const createConstatGravity: SubmitHandler<SchemaFormConstatGravity> =
    useCallback(
      async (values) => {
        try {
          await lazyCreateConstatGravity(values).unwrap();
          notification.success({ message: "GravitÃ© de constat crÃ©Ã©e avec succÃ¨s." });
          onHideModal();
          fetchConstatGravities();
        } catch (e) {
          notification.error({ message: "Erreur", description: getErrorMessage(e) });
        }
      },
      [lazyCreateConstatGravity, fetchConstatGravities, onHideModal],
    );

  const updateConstatGravity: SubmitHandler<SchemaFormConstatGravity> =
    useCallback(
      async (values) => {
        try {
          await lazyUpdateConstatGravity({ constatGravityId, values }).unwrap();
          notification.success({ message: "GravitÃ© de constat modifiÃ©e avec succÃ¨s." });
          onHideModal();
          fetchConstatGravities();
        } catch (e) {
          notification.error({ message: "Erreur", description: getErrorMessage(e) });
        }
      },
      [constatGravityId, lazyUpdateConstatGravity, fetchConstatGravities, onHideModal],
    );

  const onDelete = useCallback(
    async (id: number) => {
      try {
        await lazyDeleteConstatGravity(id).unwrap();
        notification.success({ message: "GravitÃ© de constat supprimÃ©e avec succÃ¨s." });
        fetchConstatGravities();
      } catch (e) {
        notification.error({ message: "Erreur", description: getErrorMessage(e) });
      }
    },
    [lazyDeleteConstatGravity, fetchConstatGravities],
  );

  return {
    createConstatGravity,
    isCreating,
    updateConstatGravity,
    isUpdating,
    onDelete,
    isDeleting,
  };
};
